<template>
<!-- eslint-disable -->
  <div style="height: 100%">
    <v-breadcrumbs :items="breadcrumbs" class="font-weight-bold">
      <v-icon slot="divider">mdi-chevron-right</v-icon>
    </v-breadcrumbs>
    <v-container class="pt-0">
      <v-row no-gutters justify="center">
        <span class="text-h5 viralYellow--text" style="font-weight: bold">{{titulo}}</span>
      </v-row>
      <slot/>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      default: null
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
